<template>
  <v-container fluid>
    <router-view></router-view>
    <!-- <v-row>
      <v-col> -->
        <!-- <v-card> -->
          <!-- <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">Clients</v-toolbar-title>
          </v-toolbar> -->
          <v-row>
            <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '5'" class="clients-setting-default-height">
              <StandardClientsList @removeClient="removeClient($event)" @selectIndex="selectIndex($event), add_new=false" :clients="getUserClients" :selected_index="selected_index">
                <template #add-client>
                  <v-list-item v-if="hasPermission('Client CREATE')">
                    <v-list-item-avatar class="cursor-pointer" :color="add_new ? 'green' : 'grey'" small @click="!add_new ? add_new = true : addClient({
                        payload: new_client
                      })">
                      <v-icon v-if="!add_new">add</v-icon>
                      <v-icon class="ml-1" v-else>send</v-icon>
                    </v-list-item-avatar>
                    <div v-if="add_new">
                      <v-list-item-content>
                        <StandardTextfield
                          color="grey darken-1"
                          textcolor="white"
                          placeholder="CLIENT.name"
                          :value="new_client.name"
                          @changeValue="setNewClientName($event)"
                          style="width: 90%"
                          />
                        <StandardTextfield
                          color="grey darken-1"
                          textcolor="white"
                          placeholder="CLIENT.base_uri"
                          :value="new_client.base_uri"
                          @changeValue="setNewClientUri($event)"
                          style="width: 90%"
                          />
                          <v-alert v-if="client_add_err" type="error" @click="client_add_err = !client_add_err">
                            Client name has to have between 1 and 100 characters. <br>
                            Client base uri has to start with either "http://" or "https://" and can have up to 500 characters.
                          </v-alert>
                      </v-list-item-content>
                    </div>
                    <v-list-item-content v-else @click="add_new = true" class="cursor-pointer">
                      {{$t("Account.AccountClients.AddClient")}}
                    </v-list-item-content>
                  </v-list-item>
                  <!-- <v-list-item> -->

                  <!-- </v-list-item> -->

                </template>
              </StandardClientsList>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '7'" class="clients-setting-height">
              <StandardClientsDetails
                @removeClientFromProject="removeClientFromProject($event)"
                @removeCallback="removeCallback($event)"
                @addCallbacks="addCallbacks($event)"
                @updateClient="updateClientLocal($event)"
                @updateCallback="updateCallback($event)"
                :client="getUserClients[selected_index]">
              </StandardClientsDetails>
            </v-col>
          </v-row>
        <!-- </v-card> -->
      <!-- </v-col>
    </v-row> -->
  </v-container>
</template>
<script>
import StandardClientsList from '@/components/StandardComponents/StandardClientsList.component.vue'
import StandardClientsDetails from '@/components/StandardComponents/StandardClientsDetails.component.vue'
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue'
import { mapGetters, mapActions } from 'vuex';
import store from '@/store/index';
export default {
  name: 'Account',
  components: {
    StandardClientsList,
    StandardClientsDetails,
    StandardTextfield
  },
  beforeRouteEnter(to, from, next){
    store.dispatch('Client/requestUserClients').then( () => { next(); });
  },
  data: function() {
    return {
      add_new: false,
      client_add_err: false,
      show_delete: false,
      selected_index: 0,
      new_client: {
        name: '',
        base_uri: ''
      }
    }
  },
  computed: {
    ...mapGetters('Auth', [
      'hasPermission'
    ]),
    ...mapGetters('Client', [
      'getUserClients'
    ]),
  },
  methods: {
    selectIndex(index){
      this.selected_index = index;
    },
    setNewClientName(event){
      this.new_client.name = event;
    },
    setNewClientUri(event){
      this.new_client.base_uri = event;
    },
    updateClientLocal(event){
      this.updateClient({
        data: event,
        client_id: this.getUserClients[this.selected_index].id
      });
    },
    addClient(payload){
      let self=this;
      this.createClient(payload).then(() => {
        self.resetNewClient();
      }).catch(() => {
        self.client_add_err = true;
      });
    },
    resetNewClient(){
      this.new_client = {
        name: '',
        base_uri: ''
      };
      this.add_new = false;
    },
    resetClientDetails(){
      this.selected_index = 0;
      this.show_delete = false;
    },
    addCallbacks(payload){
      payload.payload.takt_entity = this.translateTAKTEntity(payload.payload.takt_entity);
      console.log('add callback!', payload);
      this.createCallback(payload);
    },
    removeCallback(payload){
      payload.client_id = this.getUserClients[this.selected_index].id;
      this.deleteCallback(payload);
    },
    translateTAKTEntity(entity){
      switch (entity) {
        case 'Project WORK.package':
          return 'TWorkPackage';
        case 'Project WORK.step':
          return 'TWorkStep';
        case 'Project QUALITY.step':
          return 'TQualityStep';
        case 'Project DEFECT.step':
          return 'TDefectStep';
        case 'Project DESIGN.step':
          return 'TDesignStep';
        case 'Project HANDOVER.step':
          return 'THandoverStep';
        case 'Project LOGISTIC.step':
          return 'TLogisticStep';
        case 'Project COST.step':
          return 'TCostStep';
        case 'Project MATERIAL.step':
          return 'TMaterialStep';
        case 'Project Material':
          return 'TMaterial';
        case 'Project WAGON':
          return 'TWaggon';
        case 'Project TAKT.area':
          return 'TaktArea';
        case 'Project TRAIN':
          return 'Train';
        case 'Company Sequence':
          return 'BSequence';
        case 'Company Sequence Wagon':
          return 'BSWaggon';
        case 'Company Sequence WORK.package':
          return 'BSWorkPackage';
        case 'Company Sequence WORK.step':
          return 'BSWorkStep';
        case 'Company Sequence QUALITY.step':
          return 'BSQualityStep';
        case 'Company Sequence DEFECT.step':
          return 'BSDefectStep';
        case 'Company Sequence DESIGN.step':
          return 'BSDesignStep';
        case 'Company Sequence LOGISTIC.step':
          return 'BSLogisticStep';
        case 'Company Sequence HANDOVER.step':
          return 'BSHandoverStep';
        case 'Company Sequence COST.step':
          return 'BSCostStep';
        case 'Company Sequence TOOL.step':
          return 'BSToolStep';
        case 'Company Sequence MATERIAL.step':
          return 'BSMaterialStep';
        case 'Company WORK.package':
          return 'BWorkPackage';
        case 'Company WORK.package WORK.step':
          return 'BWWorkStep';
        case 'Company WORK.package QUALITY.step':
          return 'BWQualityStep';
        case 'Company WORK.package DEFECT.step':
          return 'BWDefectStep';
        case 'Company WORK.package DESIGN.step':
          return 'BWDesignStep';
        case 'Company WORK.package LOGISTIC.step':
          return 'BWLogisticStep';
        case 'Company WORK.package HANDOVER.step':
          return 'BWHandoverStep';
        case 'Company WORK.package COST.step':
          return 'BWCostStep';
        case 'Company WORK.package TOOL.step':
          return 'BWToolStep';
        case 'Company WORK.package MATERIAL.step':
          return 'BWMaterialStep';
        default:
          return entity;
      }
    },
    removeClient(payload){
      this.deleteClient(payload);
      this.selected_index = 0;
    },
    ...mapActions('Client', [
      'createCallback',
      'updateClient',
      'updateCallback',
      'deleteCallback',
      'deleteClient',
      'createClient',
      'removeClientFromProject'
    ])
  }
}
</script>

<style lang="scss" scoped>
// .clients-setting-height {
//   max-height: 600px;
//   overflow: hidden;
// }
// .clients-setting-default-height {
//   max-height: 600px;
//   overflow-y: auto;
// }
.list-item-bg {
  background-color: red;
}
</style>
